module.exports = __webpack_public_path__ + "img/photo.b50340f9.png";